const localState: Record<string, any> = {};

export default localState;
